// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2lnP2","title":"FrontImage_title__3fA82"};